import React, {useState, useEffect} from 'react'
import css from './styles.module.scss'
import LayoutDefault from '../../../layouts/default'
import { NotificationManager } from 'react-notifications'
import { useParams, Link, useHistory } from "react-router-dom"
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import { getAditional } from '../../../http/subscriptionAditionalContent'
import { FaArrowLeft, FaDownload } from 'react-icons/fa'
import AditionalContents from '../../../assets/aditionalContent.png'
import Vimeo from '@u-wave/react-vimeo'
import YouTube from 'react-youtube'
const server = process.env.REACT_APP_API_URL || null

const SubscriptionAditionalContent = () => {
	const params = useParams()
  if (!params.aditionalContentId)
		window.href = '/'

	const aditionalContentId = params.aditionalContentId

	const [aditionalContent, setAditionalContent] = useState(null)
	const [loading, setLoading] = useState(true)
  const [style, setStyle] = useState(null)

  const history = useHistory()

  const getRandomArbitrary = (min, max) => (Math.random() * (max - min) + min)

  const generateRandom = (count = 0) => {
    let sum = count + 1
    if (sum > 3){
      setStyle({
        position:'absolute', 
        zIndex: '5000', 
        top: `${getRandomArbitrary(25, 75)}%`, 
        left: `${getRandomArbitrary(25, 75)}%`, 
        color: 'yellow',
        fontSize: '25px',
        textShadow: "-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black"
      })
      sum = 0
    } else {
      setStyle({ display: 'none' })
    }
    var rand = getRandomArbitrary(10, 20)
    setTimeout(() => generateRandom(sum), rand * 1000);
  }

  const showContent = () => {
    switch(aditionalContent.type){
      case 'youtube':
        var video_id = aditionalContent.content.split('v=')[1]
        var ampersandPosition = video_id ? video_id.indexOf('&') : -1
        if(ampersandPosition !== -1)
          video_id = video_id.substring(0, ampersandPosition)
        return (
          <div className={css["video-container"]}>
            <div className={css["video-container__content"]}>
            < YouTube
              videoId={video_id}
              id="ytplayer"
            />
            </div>
            <div className={css["video-container__logo"]}>
              <img src={`${server}${aditionalContent.company.logoUrl}`} />
            </div>
          </div>
        )
      case 'vimeo':
        return (
          <div className={css["video-container"]}>
            <div className={css["video-container__content"]}>
              <Vimeo
                video={aditionalContent.content}
                autoplay={false}
                speed={true}
                width="640" 
                height="360"
              />
            </div>
          </div>
        )
      case 'image':
        return (
          <div className={css["image-container"]}>
            <img src={`${server}${aditionalContent.linkAttachment}`} alt={aditionalContent.name} />
          </div>
        )
      case 'text':
        return <div className={css["text-container"]} dangerouslySetInnerHTML={{__html: aditionalContent.content}}></div>
      default:
        return (
          <Container className={css["document-container"]}>
            <a href={`${server}${aditionalContent.linkAttachment}`} target="_blank" rel="noreferrer">
              <FaDownload />
              {aditionalContent.name}
            </a>
          </Container>
        )
    }
  }

  useEffect(()=> {
    document.title = `Aula - Alissem`
    document.getElementsByTagName("META")[1].content=document.title
    fetchAditionalContent()
  }, [])


  const fetchAditionalContent = () => {
    getAditional(aditionalContentId).then(e => {
      setAditionalContent(e.data)
      setLoading(false)
    }).catch((e) => {
      if (e.response?.status === 401){
        history.replace('/')
        return 
      }
      NotificationManager.error('Erro no servidor! Recarregue a página.', 'Ocorreu um erro')
    })
  }

  useState(() => {
    if (aditionalContent && aditionalContent.type === 'youtube')
      generateRandom()
  }, aditionalContent)

	return (
		<LayoutDefault loading={loading}>
      {!loading && aditionalContent &&
        <div className={css['pg-aditionalContent']}>
          <div className={css['pg-aditionalContent__header']}>
            <Container className={css['pg-aditionalContent__header__container']}>
              <img src={AditionalContents} alt=""/>
              <h2 className={css['pg-aditionalContent__header__title']}>
                {aditionalContent.name}
              </h2>
              </Container>
          </div>
          <Container>
          {showContent()}
            <Link 
              to={`/empresa/${aditionalContent.company.permalink}`} 
              className={css['pg-aditionalContent__back']}
            >
              <FaArrowLeft />
              <p>Voltar para a empresa</p>
            </Link>
          </Container>
        </div>
      }
		</LayoutDefault>
	)
}

export default SubscriptionAditionalContent